import { render, staticRenderFns } from "./FileTag.vue?vue&type=template&id=1b8f38f9&scoped=true&"
import script from "./FileTag.vue?vue&type=script&lang=js&"
export * from "./FileTag.vue?vue&type=script&lang=js&"
import style0 from "./FileTag.vue?vue&type=style&index=0&id=1b8f38f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f38f9",
  null
  
)

export default component.exports